import { DOMUtils } from '../../utils/dom'
import { IWidgetAdapter } from './adapters/adapter'
import { Distroscale } from './adapters/distroscale'
import { FlyerCity } from './adapters/flyercity'
import { Origami } from './adapters/origami'
import { OwnLocal } from './adapters/ownlocal'
import { Slimcut } from './adapters/slimcut'

export enum WidgetType {
    DISTROSCALE = 'distroscale',
    FLYERCITY = 'flyercity',
    OWNLOCAL = 'ownlocal',
    ORIGAMI = 'origami',
    SLIMCUT = 'slimcut'
}

export class WidgetService {
    public static DOM = {
        attrs: {
            widget: 'data-widget'
        }
    }
    public widgets: IWidgetAdapter[] = []

    /**
     * Load all of the widgets exposed to the DOM
     */
    public async initialize(adLight: boolean) {
        await DOMUtils.ready
        DOMUtils.nodes(document.querySelectorAll(`[${WidgetService.DOM.attrs.widget}]`))
            .forEach((element: Element) => {
                // tslint:disable-next-line: no-unnecessary-initializer
                let widget = undefined
                switch(element.getAttribute(WidgetService.DOM.attrs.widget)) {
                    case WidgetType.DISTROSCALE:
                        widget = new Distroscale(element, adLight)
                        break
                    case WidgetType.FLYERCITY:
                        widget = new FlyerCity(element, adLight)
                        break
                    case WidgetType.ORIGAMI:
                        widget = new Origami(element, adLight)
                        break
                    case WidgetType.OWNLOCAL:
                        widget = new OwnLocal(element, adLight)
                        break
                    case WidgetType.SLIMCUT:
                        widget = new Slimcut(element, adLight)
                        break
                }
                if (widget) {
                    this.widgets.push(widget)
                }
                return widget
        })
    }

    /**
     *  update the widgets exposed to ad-lite in the DOM
     */
    public async update(adLight: boolean) {
        if(adLight) {
            for (const widget of this.widgets) {
                widget.removeWidgetContainer()
            }
        }
    }
}
